import BaseError from '@whr/core_utils/baseError.js'

type UpdateUserErrorReason = 'update-user-failed'

export class UpdateUserError extends BaseError<UpdateUserErrorReason> {
  constructor (message: string, originalError?: any) {
    super('update-user-failed', message, originalError, 500)
  }
}
